/**
 * Content items (spec 40 §4.2-§4.6, S40-2): value sets and field limits shared
 * by API (validation, OpenAPI), worker (AI appliers, module 80) and web. The
 * database repeats them as CHECKs (migration 0021).
 */
export const CONTENT_STATUSES = ['idea', 'draft', 'in_review', 'changes_requested', 'approved', 'archived'];
/** Statuses a new item may start in; every later change goes through module 50. */
export const INITIAL_CONTENT_STATUSES = ['idea', 'draft'];
export const CONTENT_PRIORITIES = ['low', 'normal', 'high'];
/** Same value set as `media_assets.season` (spec 30). */
export const CONTENT_SEASONS = ['spring', 'summer', 'autumn', 'winter', 'all_year'];
/** Provenance, never a status (ADR-006). */
export const CONTENT_ORIGINS = ['human', 'ai', 'external'];
export const CONTENT_VERSION_AUTHOR_TYPES = ['user', 'ai_job', 'external'];
/** What a version changed; new values are non-breaking additions. */
export const CONTENT_CHANGE_KINDS = [
    'created',
    'details_changed',
    'text_changed',
    'localization_added',
    'localization_removed',
    'variant_added',
    'variant_removed',
    'media_changed',
    'design_changed',
    'storyboard_changed',
    'tags_changed',
    'variant_link_changed',
    'restored',
];
/** The language of a bilingual localization; its `languages` list names the contained ones (REQ-40-006). */
export const MULTILINGUAL_LANGUAGE = 'mul';
export const CONTENT_LIMITS = {
    titleMaxLength: 200,
    descriptionMaxLength: 5000,
    headlineMaxLength: 300,
    captionMaxLength: 10000,
    ctaMaxLength: 300,
    hashtagMaxLength: 100,
    /** A sanity bound for storage, far above any platform limit (the platform counters are advisory). */
    maxHashtags: 100,
    /** Languages of one bilingual (`mul`) localization. */
    maxMultilingualLanguages: 5,
    maxLocalizationsOnCreate: 20,
};
/** A hashtag without its leading `#`: letters, digits and underscore only, 1-100 characters. */
export const HASHTAG_PATTERN = /^[\p{L}\p{N}_]{1,100}$/u;
/** The stored form of a hashtag (leading `#` removed) or `null` when it is malformed. */
export function normalizeHashtag(value) {
    if (typeof value !== 'string')
        return null;
    const tag = value.trim().replace(/^#/, '');
    return HASHTAG_PATTERN.test(tag) ? tag : null;
}
//# sourceMappingURL=content.js.map